export default "__VITE_ASSET__CN10BZa9__"